// app/src/App.js
import { Route, Routes } from "react-router-dom";
import { createContext, Suspense } from "react";
import AppConfigProvider from "./contexts/AppConfigContext";

import Layout from "./components/Layout";

import PageNotFound from "./features/page_not_found/PageNotFound";
import LayoutMain from "./components/LayoutMain";
import Public from "./components/Public"
import Login from "./features/auth/Login"
import About from "./components/About"
import PersistLogin from "./features/auth/PersistLogin"
import RequireAuth from "./features/auth/RequireAuth"
import Prefetch from "./features/auth/Prefetch"
import useTitle from './hooks/useTitle';

import UsersPage from "./features/users/UsersPage";
import EditUser from "./features/users/EditUser"
import NewUser from "./features/users/NewUser";
import Helpsupports from "./features/helpsupports/Helpsupports";
import NotesList from "./features/notes/NotesList";
import EditNote from "./features/notes/EditNote";
import NewNote from "./features/notes/NewNote";
import SettingsList from "./features/settings/SettingsList";
import EditSetting from "./features/settings/EditSetting";
import CampaignsList from "./features/campaigns/CampaignsList";
import EditCampaign from "./features/campaigns/EditCampaign";
import NewCampaign from "./features/campaigns/NewCampaign";
import BusinessdetailsList from "./features/businessdetails/BusinessdetailsList";
import EditBusinessdetail from "./features/businessdetails/EditBusinessdetail";
import NewBusinessdetail from "./features/businessdetails/NewBusinessdetail";
import SalesList from "./features/sales/SalesList";
import EditSale from "./features/sales/EditSale";
// import NewSale from "./features/sales/NewSale";
import Home from "./features/blogs/public/Home";
import HomeProductLow from "./features/blogs/public/HomeProductLow";
import HomeCampaign2026 from "./features/blogs/public/HomeCampaign2026";
import BlogsList from "./features/blogs/public/BlogsList";
import BlogDetail from "./features/blogs/public/BlogDetail";
import MissionVision from "./features/blogs/public/MissionVision";
import BlogsAdminList from "./features/blogs/admin/BlogsAdminList";
import NewBlog from "./features/blogs/admin/NewBlog";
import EditBlog from "./features/blogs/admin/EditBlog";
import DistinctSalesList from "./features/sales/DistinctSalesList";
import OrdersList from "./features/orders/OrdersList";
// import EditOrder from "./features/orders/Order";
// import NewOrder from "./features/orders/NewOrder";
import Withholding_docsList from "./features/withholding_docs/Withholding_docsList";
import TaxDashboard from "./features/tax/TaxDashboard";
// import EditWithholding_doc from "./features/withholding_docs/Withholding_doc";
// import NewWithholding_doc from "./features/withholding_docs/NewWithholding_doc"; 

import DashboardLanding from "./features/dashboard/DashboardLanding";
import TaxPayersList from "./features/taxpayers/TaxPayersList";
import NewTaxPayer from "./features/taxpayers/NewTaxPayer";
import EditTaxPayer from "./features/taxpayers/EditTaxPayer";
import TaxPayerDetail from "./features/taxpayers/TaxPayerDetail";

// Create a context
export const ProjectContext = createContext();

function App() {
  useTitle('MudahTechnology — Transformasi organisasi IT dengan AI');  

  return (  
      <AppConfigProvider>
        <Suspense fallback={<div className="p-6 text-sm text-gray-500">Loading…</div>}>
          <Routes>
            <Route path="/" element={<LayoutMain />}>
              {/* public routes */}
              {/* <Route index element={<Home />} /> */}
              {/* <Route index element={<HomeProductLow />} /> */}
              <Route index element={<HomeCampaign2026 />} />
              <Route path="first-time-use" element={<Public />} />
              <Route path="blogs" element={<BlogsList />} />
              <Route path="/blogs/:slug" element={<BlogDetail />} />
              <Route path="/mission-vision" element={<MissionVision />} />
              <Route path="login" element={<Login />} />
              <Route path="about" element={<About />} />

              {/* Protected Routes */}
			<Route element={<PersistLogin />}>
				<Route element={<Prefetch />}>
				<Route path="dash" element={<Layout />}>
					<Route index element={<DashboardLanding />} />

					<Route element={<RequireAuth allowedRoles={["GLOBAL_ADMIN"]} />}>
						<Route path="users">
							<Route index element={<UsersPage />} />
							<Route path=":id" element={<EditUser />} />
							<Route path="new" element={<NewUser />} />
						</Route>

						<Route path="system">
							<Route index element={<SettingsList />} />
							<Route path=":id" element={<EditSetting />} />
						</Route>
					</Route>

					<Route element={<RequireAuth app="POS_APPLICATION" />}>
						<Route path="orders">
							<Route index element={<OrdersList />} />
							{/* <Route path=":id" element={<EditOrder />} /> */}
							{/* <Route path="new" element={<NewOrder />} /> */}
						</Route>
					</Route>

					<Route element={<RequireAuth app="PAJAK_AUTOMATION" />}>
						<Route path="withholding_docs" element={<Withholding_docsList />} />
						<Route path="tax" element={<TaxDashboard />} />
						<Route path="taxpayers" element={<TaxPayersList />} />
						<Route path="taxpayers/:id" element={<TaxPayerDetail />} />
						<Route path="taxpayers/new" element={<NewTaxPayer />} />
						<Route path="taxpayers/edit/:id" element={<EditTaxPayer />} />

					</Route>

					<Route element={<RequireAuth app="PROPERTY_ASSISTANT" />}>
						<Route path="notes">
							<Route index element={<NotesList />} />
							<Route path=":id" element={<EditNote />} />
							<Route path="new" element={<NewNote />} />
						</Route>

						<Route path="campaigns">
							<Route index element={<CampaignsList />} />
							<Route path=":id" element={<EditCampaign />} />
							<Route path="new" element={<NewCampaign />} />
						</Route>

						<Route path="businessdetails">
							<Route index element={<BusinessdetailsList />} />
							<Route path=":id" element={<EditBusinessdetail />} />
							<Route path="new" element={<NewBusinessdetail />} />
						</Route>

						<Route path="sales">
							<Route index element={<SalesList />} />
							<Route path="distinct" element={<DistinctSalesList />} />
							<Route path=":id" element={<EditSale />} />
							{/* <Route path="new" element={<NewSale />} /> */}
						</Route>

						<Route path="blogs">
							<Route index element={<BlogsAdminList />} />
							<Route path=":id" element={<EditBlog />} />
							<Route path="new" element={<NewBlog />} />
						</Route>
					</Route>

					<Route path="helpsupport">
						<Route index element={<Helpsupports />} />
					</Route>
				</Route>{/* End Dash */}
				<Route path="*" element={<PageNotFound />} />
				</Route>			
			</Route>{/* End Protected Routes */}
            
            </Route>
          </Routes>
        </Suspense>
      </AppConfigProvider>
    // </div>
  );
}

export default App;
